(ns rlws.iot-cloud.frontend.authorization)

(def customer-user-permissions
  [:view-assets
   :view-alerts
   :view-documents
   :modify-documents])

(def service-technician-permissions
  (concat customer-user-permissions
          [:view-home
           :view-users
           :view-console
           :view-service-notes
           :modify-service-notes]))

(def service-manager-permissions
  (concat service-technician-permissions
          [:modify-assets]))

(def dealer-permissions
  (concat service-manager-permissions
          [:modify-customers]))

(def superuser-permissions
  (concat dealer-permissions
          [:modify-users
           :modify-dealerships
           :view-customers]))

(defn permissions
  [user]
  (set
   (condp #((set %2) %1) (:roles user)
     "superuser" superuser-permissions
     "dealer" dealer-permissions
     "service-manager" service-manager-permissions
     "service-technician" service-technician-permissions
     "customer-user" customer-user-permissions
     customer-user-permissions)))
